import S3UploadController from "./s3_upload_controller"

// Connects to data-controller="quick-start-upload"
// The Quick Start table page's upload. There is no table definition yet, so the presigned
// upload endpoint comes from the page rather than being built from a table id.
export default class extends S3UploadController {
  get presignedUploadUrl() {
    return this.presignedUrlValue
  }

  get uploadingText() {
    return "Uploading..."
  }

  get processingText() {
    return "Building your table..."
  }

  get defaultButtonText() {
    return "Create Table"
  }
}
